import { Connection } from '@lucidtech/las-sdk-browser';
import { useMemo } from 'react';

import { GraphClient } from './client';

export const useGraphClient = (connection?: Connection, filter?: string) => {
  const { accessToken } = connection?.credentials ?? {};
  return useMemo(() => new GraphClient(accessToken as string, filter), [accessToken, filter]);
};
